import { IBaseDataParser } from "../../../core/src/server/parsers/IBaseDataParser";
import IAuthorizationData from "../../../core/src/server/data/IAuthorizationData";

export default class GameDataParser
    implements IBaseDataParser<IAuthorizationData>
{
    // this is for Fantasma prototype server
    check(data: any): boolean {
        return false;  
    }

    parse(data): IAuthorizationData[] {
        const result = {};
        return [result];
    }
}
